import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ProductGroups from '../components/color/ProductGroups';
import TotalContainer from '../components/TotalContainer';
import Nav from '../components/Nav';
import stepAnalytics from '../utils/stepAnalytics';
import Help from '../components/help/Help';
import { standardDiscount } from '../discounts';

import Loading from '../components/Loading';

function SpecialMessage(props) {
  return (
    <div className="specialMessage">
      <div className="text">
        Kampanj: Bli sponsrad av Unisport och Leo Vegas.
      </div>
      <div
        className="read_more_btn"
        onClick={props.toggleAlert}
        role="button"
        tabIndex="0"
        style={{ outline: 'none' }}
      >
        Läs mer här
      </div>
      <div
        onClick={() => props.closeMessage()}
        className="close_btn"
        role="button"
        tabIndex="0"
        style={{ outline: 'none' }}
      >
        <span className="sg-icon icon-close-button icon-close-button-dims" />
      </div>
    </div>
  );
}

const children_kits = [
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '31',
  '33'
];

class ColorSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalContainerSticky: false,
      totalContainerLink: '/amount/',
      productGroup: props.match.params.id,
      specialMessageOpen: false
    };
    this.updateSelection = this.updateSelection.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    stepAnalytics('/colors', 'colors', 'step 1');
    window.scrollTo(0, 0);
    this.props.setGroupID(this.state.productGroup);
    this.props.requestChoices(this.state.productGroup);
    window.addEventListener('scroll', this.handleScroll);
    this.props.updateAlert('color');
    this.props.setAdultProducts(
      !children_kits.includes(this.props.match.params.id)
    );

    const id = parseInt(this.state.productGroup, 10);
    const group = window.__INITIAL_STATE__.groups.find(g => g.id === id);
    let discount = standardDiscount;
    if (group) {
      discount = `${group.discount_percentage} %`;
    }
    this.props.saveDiscount(discount);

    let groupType = 'brand';
    if (
      window.__INITIAL_STATE__.groups.find(g => g.id === id && g.type === 1)
    ) {
      groupType = 'club';
    }
    this.props.saveGroupType(groupType);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.props.postChoices(this.props.selection);
  }

  toggleHelpAlert = () => {
    this.props.toggleHelp();
  };

  toggleSpecialMessage = () => {
    this.setState({ specialMessageOpen: false });
  };

  toggleSpecialMessagePopUp = () => {
    this.props.toggleAlert('leoVegasInfo');
  };

  handleScroll() {
    if (window.pageYOffset > 175) {
      this.setState({ totalContainerSticky: true });
    } else {
      this.setState({ totalContainerSticky: false });
    }
  }

  updateSelection(newSelection) {
    this.props.updateSelection(newSelection);
  }

  render() {
    return (
      <>
        <Nav />
        {this.props.helpShown && (
          <Help
            toggleAlert={this.toggleHelpAlert}
            path={this.props.match.path}
          />
        )}
        {this.props.choices && this.props.choices.length > 0 ? (
          <div className="teamsport_content">
            <div className="main_container">
              {this.state.specialMessageOpen &&
                window.siteId === '10' &&
                this.props.isAdultProducts && (
                  <SpecialMessage
                    closeMessage={this.toggleSpecialMessage}
                    toggleAlert={this.toggleSpecialMessagePopUp}
                  />
                )}
              <div className="ColorSelection">
                <ProductGroups
                  productGroups={this.props.choices}
                  setSelectedProducts={this.selected}
                  removeSelection={this.props.removeSelection}
                  toggleHelpAlert={this.toggleHelpAlert}
                  productGroupID={this.state.productGroup}
                />
              </div>
            </div>
            <TotalContainer
              totalContainerSticky={this.state.totalContainerSticky}
              totalContainerLink={this.state.totalContainerLink}
              totalContainerLinkText={
                this.props.generalTranslations.Pick_quantity
              }
            />
          </div>
        ) : (
          <Loading />
        )}
      </>
    );
  }
}

const mapDispatch = dispatch => ({
  requestChoices: groupID =>
    dispatch({
      type: 'REQUEST_CHOICES',
      groupID
    }),
  postChoices: data =>
    dispatch({
      type: 'POST_CHOICES',
      choices: data
    }),
  setGroupID: groupID =>
    dispatch({
      type: 'SET_GROUP_ID',
      groupID
    }),
  updateAlert: alertElement =>
    dispatch({
      type: 'UPDATE',
      alertElement
    }),
  toggleAlert: alertType =>
    dispatch({
      type: 'TOGGLE',
      alertType
    }),
  setAdultProducts: bool =>
    dispatch({
      type: 'SET_ADULT_PRODUCTS',
      isAdult: bool
    }),
  toggleHelp: () =>
    dispatch({
      type: 'TOGGLE_HELP'
    }),
  saveDiscount: discount =>
    dispatch({
      type: 'SAVE_DISCOUNT',
      discount
    }),
  saveGroupType: groupType =>
    dispatch({
      type: 'SAVE_GROUP_TYPE',
      groupType
    })
});

const mapState = state => ({
  choices: state.choices,
  selection: state.selection,
  total: state.total,
  settings: state.settings,
  generalTranslations: state.generalTranslations,
  alerts: state.alerts,
  isAdultProducts: state.isAdultProducts,
  helpShown: state.helpShown
});

export default connect(mapState, mapDispatch)(ColorSelection);
